import { createContext } from "react";

const ClientContext = createContext({ client: {}, seClient: () => {} });

export default ClientContext;
